function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcTagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1019.337 562.575c-55.934 224.349-283.161 360.884-507.536 304.938-224.283-55.933-360.819-283.174-304.86-507.51C262.848 135.628 490.076-.921 714.386 55.012c224.361 55.934 360.884 283.201 304.951 507.563z",
    style: {},
    transform: "matrix(.6113 0 0 .6113 -118.804 -25.968)",
    fill: "#f7931a",
    "data-original": "#f7931a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.38 531.795c-2.277 5.654-8.048 14.134-21.057 10.914.459.668-33.397-8.336-33.397-8.336l-22.81 52.596 59.793 14.907c11.124 2.787 22.026 5.705 32.757 8.454l-19.016 76.349 45.896 11.451 18.832-75.538a1754.793 1754.793 0 0 0 36.617 9.501l-18.767 75.184 45.949 11.451 19.015-76.205c78.352 14.827 137.268 8.847 162.068-62.019 19.984-57.058-.994-89.973-42.218-111.435 30.022-6.923 52.635-26.671 58.668-67.463 8.336-55.724-34.092-85.68-92.106-105.664l18.819-75.486-45.949-11.451-18.321 73.496c-12.079-3.01-24.486-5.85-36.813-8.664l18.452-73.981-45.922-11.451-18.832 75.459c-9.999-2.277-19.813-4.529-29.341-6.897l.052-.236-63.367-15.822-12.224 49.076s34.092 7.813 33.372 8.297c18.61 4.646 21.973 16.96 21.411 26.724L475.38 531.795zm217.347 17.026c-14.199 57.058-110.27 26.212-141.417 18.478l25.232-101.148c31.146 7.773 131.025 23.163 116.185 82.67zm14.212-148.039c-12.956 51.903-92.917 25.533-118.855 19.068l22.876-91.74c25.938 6.465 109.472 18.531 95.979 72.672z",
    style: {},
    transform: "matrix(.6113 0 0 .6113 -118.804 -25.968)",
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcTagIcon);
export default __webpack_public_path__ + "static/media/btc-tag-icon.b1e0a078a97dc625717e760f6783674d.svg";
export { ForwardRef as ReactComponent };